/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Rewards_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"RewardsNav_user">;
    readonly " $refType": "Rewards_user";
};
export type Rewards_user$data = Rewards_user;
export type Rewards_user$key = {
    readonly " $data"?: Rewards_user$data;
    readonly " $fragmentRefs": FragmentRefs<"Rewards_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Rewards_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "RewardsNav_user",
      "args": null
    }
  ]
};
(node as any).hash = 'aa3172776739dc69e0a28b1972c45cb4';
export default node;
